var map = {
	"./admin.svg": 6678,
	"./automacao.svg": 72841,
	"./cadastros.svg": 58783,
	"./cell-tower.svg": 67913,
	"./cliente.svg": 7945,
	"./clientes.svg": 89384,
	"./dashboard.svg": 58703,
	"./dispositivos.svg": 33759,
	"./e-sim.svg": 15668,
	"./elipse-preenchida.svg": 68007,
	"./elipse.svg": 52925,
	"./financeiro.svg": 26431,
	"./fornecedor.svg": 39972,
	"./historico.svg": 7349,
	"./icone-detalhamento-consumo.svg": 36391,
	"./icone-fatura.svg": 2245,
	"./icone-olho-ligado.svg": 8297,
	"./icone-seta-dropdown.svg": 67257,
	"./informacoes.svg": 20533,
	"./localizacao.svg": 49431,
	"./manutencao.svg": 92288,
	"./pedidos.svg": 87653,
	"./relatorios.svg": 13381,
	"./simcard-vigem.svg": 46991,
	"./simcard.svg": 50320,
	"./sms.svg": 1444,
	"./solicitacoes.svg": 95713,
	"./usuarios.svg": 4550,
	"./virtueyes.svg": 66215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90699;